import React, { useEffect, useState  } from 'react';
import "./recruiter_new_lp.scss";

interface FAQItemProps {
    question: string;
    answer: string;
  }


  const FAQItem: React.FC<FAQItemProps> = ({ question, answer }) => {
    const [showAnswer, setShowAnswer] = useState(false);
  
    const toggleAnswer = () => {
      setShowAnswer(!showAnswer);
    };
    const display = {
        display: 'block',
      };
  
    return (
      <li>
        <h3 onClick={toggleAnswer} className={showAnswer ? 'active' : ''}>
          {question}
        </h3>
        {/* {showAnswer && (
        <p style={display} dangerouslySetInnerHTML={{ __html: answer.replace(/\n/g, '<br />') }} />
        
        )} */}
        {showAnswer && (
            <p style={display} dangerouslySetInnerHTML={{ __html: answer }} />
        )}
      </li>
    );
  };


function Recruiter() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        document.body.style.lineHeight = "1.6875";
        const script = document.createElement('script');      
        script.src = "/assets/js/lp_main.js";
        document.body.appendChild(script);
//         <link rel="preconnect" href="https://fonts.googleapis.com">
// <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
// <link href="https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet"></link>

        const link = document.createElement('link');
        link.href = 'https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap';
        link.rel = 'stylesheet';
        document.head.appendChild(link);

        const script0 = document.createElement('script');
        script0.type = "text/javascript";
        script0.src ='https://app.chatplus.jp/cp.js';
        document.head.appendChild(script0);

        const script1 = document.createElement('script');
        script1.type = "text/javascript";
        script1.src ='https://app.chatplus.jp/assets/js/app/chatplusscript.min.js?v=1890840';
        document.head.appendChild(script1);

        const script2 = document.createElement('script');
        script2.type = "text/javascript";
        script2.setAttribute('data-requirecontext', '_');
        script2.setAttribute('data-requiremodule', 'jQueryPlus');
        script2.src ='https://appimg.chatplus.jp/app/s/lib/jqueryc.min.js';
        document.head.appendChild(script2);

        const script3 = document.createElement('script');
        script3.type = "text/javascript";
        script3.setAttribute('data-requirecontext', '_');
        script3.setAttribute('data-requiremodule', 'riot');
        script3.src ='https://appimg.chatplus.jp/app/s/lib/riot/3.13.2/riot%2Bcompiler_2.min.js';
        document.head.appendChild(script3);

        const script4 = document.createElement('script');
        script4.type = "text/javascript";
        script4.setAttribute('data-requirecontext', '_');
        script4.setAttribute('data-requiremodule', 'underscore');
        script4.src ='https://appimg.chatplus.jp/app/s/lib/underscore/underscorec.min.js';
        document.head.appendChild(script4);

        const script5 = document.createElement('script');
        script5.type = "text/javascript";
        script5.src ='https://app.chatplus.jp/assets/js/app/onerror.min.js';
        document.head.appendChild(script5);

        // const script6 = document.createElement('script');
        // script6.type = "riot/javascript";
        // script6.src ='https://app.chatplus.jp/assets/js/riot-tags/output.tag.js?v=20231201';
        // document.head.appendChild(script6);

        // const script7 = document.createElement('script');
        // script7.type = "riot/javascript";
        // script7.src ='https://app.chatplus.jp/assets/js/riot-tags/chat.tag.js?v=20231201';
        // document.head.appendChild(script7);

        // const script8 = document.createElement('script');
        // script8.src ='https://app.chatplus.jp/assets/js/app/visitor-client.min.js?v=20231201';
        // document.head.appendChild(script8);

        const script9 = document.createElement('script');
        script9.src ='https://appimg.chatplus.jp/app/s/lib/slick.min.js';
        document.head.appendChild(script9);

        return () => {
          document.body.removeChild(script);
        //   document.head.removeChild(link);
          document.head.removeChild(script0);
          document.head.removeChild(script1);
          document.head.removeChild(script2);
          document.head.removeChild(script3);
          document.head.removeChild(script4);
          document.head.removeChild(script5);
        //   document.head.removeChild(script6);
        //   document.head.removeChild(script7);
        //   document.head.removeChild(script8);
          document.head.removeChild(script9);
        }
    }, []);

    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };
  
    useEffect(() => {
      window.addEventListener('scroll', toggleVisibility);
      return () => {
        window.removeEventListener('scroll', toggleVisibility);
      };
    }, []);
    
    // return (
    //     <main id="lp">
    //         <section id="mv">
    //             <img src="/assets/img/lp/mv.jpg" alt="障がい者雇用特化型求人マッチングサイト パラちゃんねる"/>
    //             <div className="link_box">
    //             <a href="/recruiter/signup/" className="btn">新規登録はこちらから！</a>
    //             <a href="/recruiter/login/" className="btn">既にご登録の企業様はこちら</a>
    //             </div>
    //             <div className={`fixed_box ${visible ? 'active' : ''}`}>
    //             <p>無料で求人掲載を始めたい方はこちら</p>
    //             <a href="/recruiter/signup/" className="btn">求人掲載を始める</a>
    //             <a href="/recruiter/login/">既に会員の企業様はこちら</a>
    //             </div>
    //         </section>
    //         <section id="worry">
    //             <h2 className="ttl_lp type1">人事担当者の皆様、<br className="sp_only"/>こんなお悩みはありませんか？</h2>
    //             <div className="wrapper">
    //             <div className="cont1">
    //                 <div>
    //                 <ul>
    //                     <li>初めての障がい者採用</li>
    //                     <li>もっと手軽に使いたい</li>
    //                 </ul>
    //                 <img src="/assets/img/lp/worry_icon01.png" alt="イラスト1"/>
    //                 </div>
    //                 <div>
    //                 <ul>
    //                     <li>あまり費用は<br/>かけられない…</li>
    //                     <li>もっと求職者のことを<br/>知りたい</li>
    //                 </ul>
    //                 <img src="/assets/img/lp/worry_icon02.png" alt="イラスト2"/>
    //                 </div>
    //             </div>
    //             <div className="cont2">
    //                 <h3>パラちゃんねるなら、<br className="sp_only"/>こんなことができます。</h3>
    //                 <ul>
    //                 <li>
    //                     <h4>手軽さ</h4>
    //                     <p>求人掲載料無料<br className="pc_only"/>ハローワーク転載</p>
    //                 </li>
    //                 <li>
    //                     <h4>安心感</h4>
    //                     <p> 特化型だからこその<br className="pc_only"/>情報量</p>
    //                 </li>
    //                 <li>
    //                     <h4>相互理解</h4>
    //                     <p>マッチング機能<br/>コラム/動画機能<br className="pc_only"/>＝納得の採用へ</p>
    //                 </li>
    //                 </ul>
    //             </div>
    //             </div>
    //         </section>
    //         <section id="feature" >
    //          <h2 className="ttl_lp type1"> <img src="/assets/img/lp/feature_ttl.svg" alt="パラちゃんねる"/> 求人サイトの特徴</h2>
    //             <ul className="wrapper">
    //                 <li>
    //                     <p className="number"><img src="/assets/img/lp/feature_number01.svg" alt="1"/></p>
    //                     <h3>
    //                         <span>障がい者求人に特化！</span><br/>
    //                         <span>求人掲載が<span>0円</span>！</span>
    //                     </h3>
    //                     <p>一人でも多く、<br/>
    //                     納得の就業機会を増やしたい。<br/>
    //                     そんな想いから、求人掲載は<br/>
    //                     2年間完全無料！</p>
    //                 </li>
    //                 <li>
    //                     <p className="number"><img src="/assets/img/lp/feature_number02.svg" alt="2"/></p>
    //                     <h3>
    //                     <span>合否連絡が自動で完結！</span><br/>
    //                     <span><span>「採用決定」</span>に集中できる設計。</span>
    //                     </h3>
    //                     <p>合否連絡の一部自動化や<br/>
    //                     選考設定の効率化により<br/>
    //                     工数のかかる選考調整・連絡を効率化！</p>
    //                 </li>
    //                 <li>
    //                     <p className="number"><img src="/assets/img/lp/feature_number03.svg" alt="3"/></p>
    //                     <h3>
    //                     <span>ハローワーク求人の</span><br/>
    //                     <span>転載ができるから</span><br/>
    //                     <span><span>3分</span>で掲載スタート！</span>
    //                     </h3>
    //                     <p>本サイトはハローワークと<br/>
    //                     連携しているので、<br/>
    //                     求人掲載は求人番号を入力するだけ！</p>
    //                 </li>
    //             </ul>
    //             <div className="wrapper">
    //             <h3><img src="/assets/img/lp/feature_text.svg" alt="求人サイトのイメージ"/></h3>
    //             <img src="/assets/img/lp/feature_img.png" alt="求人サイトのイメージ"/>
    //             </div>
    //             <a href="/recruitments/6501/" className="btn">求人のサンプルを見る</a>
    //         </section>
    //         <section id="flow">
    //             <div className="wrapper">
    //             <h2 className="ttl_lp type2">ご利用の流れ 簡単<span>3</span>STEP！</h2>
    //             <ul>
    //                 <li>
    //                 <p>① HWの番号を入力</p>
    //                 <img src="/assets/img/lp/flow_img01.jpg" alt="HWの番号を入力"/>
    //                 </li>
    //                 <li>
    //                 <p>② 内容を確認</p>
    //                 <img src="/assets/img/lp/flow_img02.jpg" alt="内容を確認"/>
    //                 </li>
    //                 <li>
    //                 <p>③ ご利用スタート！</p>
    //                 <img src="/assets/img/lp/flow_img03.jpg" alt="ご利用スタート！"/>
    //                 </li>
    //             </ul>
    //             <div>
    //                 <img src="/assets/img/lp/flow_img04.png" alt=""/>
    //                 <div className="text_box">
    //                 <p>求職者のプロフィールを見て、<br/>直接応募を促せる！</p>
    //                 <h3><span>新機能！</span><br/><span>スカウト機能</span></h3>
    //                 <p>障がい者雇用初の<br/>「ダイレクトリクルーティング」が可能に！</p>
    //                 </div>
    //             </div>
    //             <a href="https://form.k3r.jp/parachannel/parachannel4corporate" target="_blank" className="btn"><span>採用担当者様向け</span>サービス資料ダウンロード<img src="/assets/img/lp/flow_icon02.svg" alt=""/></a>
    //             </div>
    //         </section>
    //         <section id="project">
    //             <div className="wrapper">
    //             <h2 className="ttl_lp type2">多様性を推進するプロジェクト<br/>「パラちゃんねる」</h2>
    //             <p>私たちは、「誰もが特性を活かせる、多様な選択肢のある社会」の実現を目指して、<br className="pc_only"/>
    //             多様な「知る」が溢れた「自由な出会い」の場を提供します。</p>
    //             <div>
    //                 <ul>
    //                 <li>
    //                     <h3><img src="/assets/img/lp/project_text01.svg" alt="パラちゃんねるラジオ"/></h3>
    //                     <p><span>2020年4月</span>より名古屋MID-FM761から障がい者に関する福祉・雇用・スポーツなどゲストを招いて放送中。</p>
    //                     <img src="/assets/img/lp/project_icon01.png" alt=""/>
    //                 </li>
    //                 <li>
    //                     <h3><img src="/assets/img/lp/project_text02.svg" alt="パラちゃんねるカフェ"/></h3>
    //                     <p><span>2021年2月</span>より障がい者雇用を促進する企業と障がいのある当事者がコラムを掲載中。2021年12月時点で<span>月間3万UU、5万PV</span>と安定して成長している。</p>
    //                     <img src="/assets/img/lp/project_icon02.png" alt=""/>
    //                 </li>
    //                 </ul>
    //                 <h3><img src="/assets/img/lp/project_text03.svg" alt="パラちゃんねる"/></h3>
    //                 <p><span>2022年1月</span>にOPENとなる障がい者雇用特化型の求人サイト。<br/>
    //                 障がい者雇用の特性を捉えたコンテンツや価格帯を実現。手間なく、気軽に出会える場を提供します。</p>
    //             </div>
    //             <div>
    //                 <h3>「パラちゃんねる」開発者たちの想い</h3>
    //                 <ul>
    //                 <li>
    //                     <div><iframe width="560" height="315" src="https://www.youtube.com/embed/dPbFjhcKgo4" title="YouTube video player"  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" ></iframe></div>
    //                     <p>「パラちゃんねる」オーナー<br/>中塚翔大インタビュー</p>
    //                 </li>
    //                 <li>
    //                     <div><iframe width="560" height="315" src="https://www.youtube.com/embed/2C5eX1vicNQ" title="YouTube video player"  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" ></iframe></div>
    //                     <p>「パラちゃんねる」UI・UX設計<br/>平田一茂インタビュー</p>
    //                 </li>
    //                 </ul>
    //             </div>
    //             </div>
    //         </section>
    //         <section id="about">
    //             <img src="/assets/img/lp/about_icon01.png" alt=""/>
    //             <a href="/recruiter/signup/" className="btn">求人掲載を始める</a>
    //             <img src="/assets/img/lp/about_icon02.png" alt=""/>
    //         </section>
    //         <section id="voice">
    //             <div className="wrapper">
    //             <h2 className="ttl_lp type3">企業ご担当者様からも<br/>応援の声をいただいています！</h2>
    //             <ul>
    //                 <li>
    //                 <img src="/assets/img/lp/voice_img01.jpg" alt=""/>
    //                 <div>
    //                     <div>
    //                     <p><span>採用コストにとらわれることなく</span>、求職者と出会えるのがすごくうれしい。<br/>
    //                     一人でも多くの方に会って採用を決定していきたい。</p>
    //                     </div>
    //                 </div>
    //                 </li>
    //                 <li>
    //                 <img src="/assets/img/lp/voice_img02.jpg" alt=""/>
    //                 <div>
    //                     <div>
    //                     <p><span>身体・精神・知的だけでなく、難病やLGBTQまで網羅</span>されていて、<br/>
    //                     社会課題に対する真摯な取り組みがうかがえる。</p>
    //                     </div>
    //                 </div>
    //                 </li>
    //                 <li>
    //                 <img src="/assets/img/lp/voice_img03.jpg" alt=""/>
    //                 <div>
    //                     <div>
    //                     <p>パラちゃんねるカフェのコラム記事は社員にも好評。<br/>
    //                     求人サイトも顧客目線で作ってもらえると期待してます。</p>
    //                     </div>
    //                 </div>
    //                 </li>
    //                 <li>
    //                 <img src="/assets/img/lp/voice_img04.jpg" alt=""/>
    //                 <div>
    //                     <div>
    //                     <p>スキルではなく、<span>相性マッチングを重視</span>しており、<br/>
    //                     現場や人事のことをよく理解できていると感じる。</p>
    //                     </div>
    //                 </div>
    //                 </li>
    //                 <li>
    //                 <img src="/assets/img/lp/voice_img05.jpg" alt=""/>
    //                 <div>
    //                     <div>
    //                     <p>これからのサービスなので、反響がどれだけあるかわからない。<br/>
    //                     ハローワークを転載できるのでまず使って見ようと思う。</p>
    //                     </div>
    //                 </div>
    //                 </li>
    //             </ul>
    //             </div>
    //         </section>
    //         <section id="comparison">
    //             <div className="wrapper">
    //             <h2 className="ttl_lp type2">他社との違い</h2>
    //             <table>
    //                 <tbody>
    //                 <tr>
    //                 <th></th>
    //                 <th>パラちゃんねる</th>
    //                 <th>求人メディア</th>
    //                 <th>人材紹介</th>
    //                 </tr>
    //                 <tr>
    //                 <th>掲載時<br className="sp_only"/>費用</th>
    //                 <td>
    //                     <img src="/assets/img/lp/comparison_icon01.svg" alt=""/>
    //                     <p>2023年12月<br className="sp_only"/>まで無料！</p>
    //                 </td>
    //                 <td>
    //                     <img src="/assets/img/lp/comparison_icon04.svg" alt=""/>
    //                     <p>1掲載あたり<br className="sp_only"/>数万〜数十万</p>
    //                 </td>
    //                 <td>
    //                     <img src="/assets/img/lp/comparison_icon02.svg" alt=""/>
    //                 </td>
    //                 </tr>
    //                 <tr>
    //                 <th>採用時<br className="sp_only"/>費用</th>
    //                 <td>
    //                     <img src="/assets/img/lp/comparison_icon01.svg" alt=""/>
    //                     <p>2023年12月<br className="sp_only"/>まで無料！</p>
    //                 </td>
    //                 <td>
    //                     <img src="/assets/img/lp/comparison_icon03.svg" alt=""/>
    //                     <p>採用時に<br className="sp_only"/>一定額</p>
    //                 </td>
    //                 <td>
    //                     <img src="/assets/img/lp/comparison_icon04.svg" alt=""/>
    //                     <p>・一律数十万<br/>・理論年収35%<br/>例:年収400万<br className="sp_only"/>×35%≒140万</p>
    //                 </td>
    //                 </tr>
    //                 <tr>
    //                 <th>掲載<br className="sp_only"/>スピード</th>
    //                 <td>
    //                     <img src="/assets/img/lp/comparison_icon01.svg" alt=""/>
    //                     <p>3分カンタン<br className="sp_only"/>掲載♪</p>
    //                 </td>
    //                 <td>
    //                     <img src="/assets/img/lp/comparison_icon03.svg" alt=""/>
    //                     <p>求人原稿<br className="sp_only"/>作成が必要</p>
    //                 </td>
    //                 <td>
    //                     <img src="/assets/img/lp/comparison_icon03.svg" alt=""/>
    //                     <p>企業による</p>
    //                 </td>
    //                 </tr>
    //                 </tbody>
    //             </table>
    //             <p>参考：マイナビ「<a href="https://www.mynavi.jp/wp-content/uploads/2019/03/%E4%B8%AD%E9%80%94%E6%8E%A1%E7%94%A8%E7%8A%B6%E6%B3%81%E8%AA%BF%E6%9F%BB.pdf" target="_blank">中途採用状況調査</a>」</p>
    //             </div>
    //         </section>
    //         <section id="faq" className="wrapper">
    //             <h2 className="ttl_lp  type3">FAQ</h2>
    //             <ul>
    //             <FAQItem
    //             question="どうして無料掲載なの？"
    //             answer="従来の求人サイトの高すぎる掲載料・手数料が生みだすスキル重視のマッチング市場は、特性や配慮などの相互理解を軸とした障がい者雇用には適しておらず、より気軽な対話の機会を増やすために無料掲載としております。"
    //             />
    //             <FAQItem
    //             question="いつまで無料で使えるの？"
    //             answer="再来年の2023年12月末まで完全無料で提供予定です。<br />
    //             以降は、サービスの月額利用料の形で一部有償する予定です。<br />
    //             (月額利用料は、5000円程度を予定しています)。"
    //             />
    //             <FAQItem
    //             question="どんな機能がある？"
    //             answer="主なサービスとしては求人掲載、スカウト機能、記事コラム作成機能、合否連絡の自動化、カンタン面接設定があります。<br />
    //             （コラム機能については2022年8月以降に利用開始予定）"
    //             />
    //             <FAQItem
    //             question="求職者の特徴は？"
    //             answer="それぞれの障がい区分ごとに全国から登録を頂いています。<br>
    //             特にコラムサイト「パラちゃんねるカフェ」では障がいのある当事者と障がい者雇用を促進する企業がコラムを連載しており、SNSを中心に発信しているため、20代、30代の方に多くご登録いただいております。 "
    //             />
    //              <FAQItem
    //             question="なぜハローワークの求人転載？"
    //             answer={`弊社は、ハローワークより認可を受けサイトポリシーに則り転載をご案内させていただいております。<br />
    //             <a href="https://www.hellowork.mhlw.go.jp/info/sitepolicy.html" target="_blank" rel="noopener noreferrer">https://www.hellowork.mhlw.go.jp/info/sitepolicy.html</a>`}
    //             />
    //             <FAQItem
    //             question="どんな雇用形態が掲載できるの？"
    //             answer="正社員、契約社員、パート・アルバイトなどの直接雇用を対象として掲載可能です。"
    //             />
    //             <FAQItem
    //             question="対象エリアは？"
    //             answer="全国で掲載可能です。"
    //             />
    //             <FAQItem
    //             question="掲載求人数の上限はあるの？"
    //             answer="完全無料の期間中は、1アカウントにつき3求人までとなっております。"
    //             />
    //            <FAQItem
    //             question="運営している会社は？"
    //             answer={`株式会社キャリアートは、障がい者専門の就職支援を行う会社となります。多様性を推進するプロジェクト「パラちゃんねる」としてラジオ、コラムサイト、本求人サイトの運営を行っています。<br>
    //             株式会社キャリアートのWEBサイトは <a href="https://www.careerart.net/" target="_blank">こちら`}
    //             />
    //             </ul>
    //         </section>
    //     </main>
       
    // );
    return (
        <>
        <div className="all_wrap">
        <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-TH9GV54"
    height="0" width="0" style={{display:"none" , visibility:"hidden"}}></iframe></noscript>
        <header className="rec_header main-lp-page">
            <div className="headeer_wrap">
            <div className="logo-lp">
                <a href="/"><img src="/assets/img/logo.svg" alt="パラちゃんねる"/></a>
            </div>
            <nav className="PC_nav">
                <ul>
                <li><a href="#feature" className='lp-menunav'><span>掲載求人の特徴</span></a></li>
                <li><a href="#comparison" className='lp-menunav'><span>サービス比較</span></a></li>
                <li><a href="#voice" className='lp-menunav'><span>採用担当者の声</span></a></li>
                <li><a href="#flow" className='lp-menunav'><span>ご利用の流れ</span></a></li>
                <li><a href="#faq" className='lp-menunav'><span>よくある質問</span></a></li>
                <li><a className="button1" href="/recruiter/signup/"><span>掲載をはじめる</span></a></li>
                <li><a className="button2" href="https://form.k3r.jp/parachannel/parachannel4corporate?k3ad=recruit_lp" target="_blank"><span>資料ダウンロード</span></a></li>
                <li><a className="txt_link" href="/recruiter/login/"><span>アカウントをお持ちの方はこちら</span></a></li>
                </ul>
            </nav>
            </div>
        </header>
            <nav className="SP_nav" id="sp_menu">
            <div>
                <a href="#close" className="menuclose">
                <span></span>
                <span></span>
                <span></span>
                <span>CLOSE</span>
                </a>
                <a href="#sp_menu" className="menuopen">
                <span></span>
                <span></span>
                <span></span>
                <span>MENU</span>
                </a>
            </div>
            <div id="sp_manu_box">
                <ul>
                <li><a href="#feature" className='lp-menunav'><span>掲載求人の特徴</span></a></li>
                <li><a href="#comparison" className='lp-menunav'><span>サービス比較</span></a></li>
                <li><a href="#voice" className='lp-menunav'><span>採用担当者の声</span></a></li>
                <li><a href="#flow" className='lp-menunav'><span>ご利用の流れ</span></a></li>
                <li><a href="#faq" className='lp-menunav'><span>よくある質問</span></a></li>
                <li><a className="button1" href="/recruiter/signup/"><span>掲載をはじめる</span></a></li>
                <li><a className="button2" href="https://form.k3r.jp/parachannel/parachannel4corporate?k3ad=recruit_lp" target="_blank"><span>資料ダウンロード</span></a></li>
                <li><a className="txt_link" href="/recruiter/login/"><span>アカウントをお持ちの方はこちら</span></a></li>
                </ul>
            </div>
            </nav>
    
        <main id="main" className="main-lp-page">
        <section className="section_mv">
            <div className="mv_box">
            <picture>
                <source media="(max-width: 950px)" srcSet="/assets/img/mv_text_sp.png"/>
                <source media="(max-width: 1140px)" srcSet="/assets/img/mv_text.png"/>
                <img src="/assets/img/mv_text.png" alt=""/>
            </picture>
            </div>
        </section>
    
        <div className="cta_box bg_blue">
            <div className="contents-container">
            <p className="h_text">毎月300人以上の新規求職者が登録中！</p>
            <div className="flex">
                <div className="button-container">
                <p className="sup_text">簡単3分</p>
                    <a className="button yellow" href="/recruiter/signup/">無料で掲載をはじめる</a>
                </div>
                <div className="button-container">
                <p className="sup_text">5分でパラちゃんねるがわかる</p>
                    <a className="button white_yellow" href="https://form.k3r.jp/parachannel/parachannel4corporate?k3ad=recruit_lp" target="_blank">資料ダウンロード</a>
                </div>
            </div>
            </div>
        </div>
    
        <section className="section_feature bg_beige">
            <div className="contents-container" id="feature">
            <h2>求人掲載の特徴</h2>
    
            <div className="flax_area">
                <img src="/assets/img/feature_photo1.jpg" alt=""/>
                <div className="text_box">
                <h3>求人掲載から採用まで完全無料<br/>コストゼロの障がい者採用</h3>
                <p className="text_w_h">従来の求人サイトの高すぎる掲載料・手数料が生みだすスキル重視のマッチング市場は、特性や配慮などの相互理解を軸とした障がい者雇用には適しておらず、より気軽な対話の機会を増やすために完全無料となっています。</p>
                </div>
            </div>
    
            <div className="flax_area reverse">
                <img src="/assets/img/feature_photo2.jpg" alt=""/>
                <div className="text_box">
                <h3>ハローワーク求人の転載で<br/>最短3分で求人掲載完了</h3>
                <p className="text_w_h">ハローワークと連携しているので、求人掲載はハローワークの求人番号を入力するだけで完了。もちろん新規求人の掲載も可能です。さらに最新のAI技術を使用して自動的に求人票のサンプル文を生成し、採用担当者の負担を大幅に軽減、魅力的な求人票を簡単に作成できます。</p>
                <p className="link"><a href="/recruitments/6501/" target="_blank"><span>求人サンプルを見る</span></a></p>
                </div>
            </div>
    
            <div className="flax_area">
                <img src="/assets/img/feature_photo3.jpg" alt=""/>
                <div className="text_box">
                <h3>特定求職者雇用開発助成金の対象</h3>
                <p className="text_w_h">ハローワークでの採用と同様に、パラちゃんねる経由の採用であっても特定求職者雇用開発助成金を申請することができます。担当者の負担を減らすために申請のサポートも行っています。</p>
                </div>
            </div>
    
            </div>
        </section>
    
        <section className="section_function bg_lattice">
            <div className="contents-container">
            <h2>パラちゃんねるだけ！<br/>便利なサポート機能</h2>
            <ul className="function_list">
                <li className="function_item">
                <img src="/assets/img/function_icon1.png" alt=""/>
                <h3>エントリーから10日間で自動で不合格ステータスに変更</h3>
                <p>不合格通知の自動化でエ数削減＋対応漏れ防止で採用したい候補者にのみ専念できる。</p>
                </li>
                <li className="function_item">
                    <img src="/assets/img/function_icon2.png" alt=""/>
                    <h3>エントリ一時点で<br/>就労支援機関との連携が<br/>可能</h3>
                    <p>就労準備性や面接同行の有無、入社後の定着支援など事前の情報収集で、安心感のある選考が安定した入社・定着を実現する。</p>
                </li>
                <li className="function_item">
                <img src="/assets/img/function_icon3.png" alt=""/>
                <h3>知りたい情報＆<br/>伝えたい情報を事前に<br/>ミスマッチを防止</h3>
                <p>求職者はアピールしたい項目を、 求人企業は事前に聞きたい項目を選択できる事前の情報開示で不必要なミスマッチが防止できる。</p>
                </li>
                <li className="function_item">
                <img src="/assets/img/function_icon4.png" alt=""/>
                <h3>ダイレクト<br/>リクルーティングで<br/>機能的な採用活動を実現</h3>
                <p>人材リサーチも可能に。新規ポジション創出の為に情報源に、スカウト経由の応募率4.9%で計画的な採用活動を実現できる。</p>
                </li>
                <li className="function_item">
                <img src="/assets/img/function_icon5.png" alt=""/>
                <h3>コラム機能で<br/>潜在的求職者にも<br/>アピールが可能</h3>
                <p>継続的な発信により滞在的な求職者がフォロワーになり、フォロワーへ情報拡散がスピーディな採用活動を実現する。</p>
                </li>
                <li className="function_item">
                <img src="/assets/img/function_icon6.png" alt=""/>
                <h3>SNS配信で<br/>企業価値の向上と<br/>新規顧客の獲得が可能</h3>
                <p>当事者ライター90名の総フォロワー数40万人以上。SNS配信で求職者と顧客や株主へのアピールを両立できる。</p>
                </li>
            </ul>
            </div>
        </section>
    
        <div className="cta_box bg_blue">
            <div className="contents-container">
            <p className="h_text">毎月300人以上の新規求職者が登録中！</p>
            <div className="flex">
                <div className="button-container">
                <p className="sup_text">簡単3分</p>
                    <a className="button yellow" href="/recruiter/signup/">無料で掲載をはじめる</a>
                </div>
                <div className="button-container">
                <p className="sup_text">5分でパラちゃんねるがわかる</p>
                    <a className="button white_yellow" href="https://form.k3r.jp/parachannel/parachannel4corporate?k3ad=recruit_lp" target="_blank">資料ダウンロード</a>
                </div>
            </div>
            </div>
        </div>
    
        <section className="section_comparison bg_stripe_yellow">
            <div className="contents-container" id="comparison">
            <h2>サービス比較</h2>
            </div>
            <div className="img_box_comparison">
            <img src="/assets/img/comparison_img.png" alt=""/>
            </div>
        </section>
    
        <section className="section_enterprise">
            <div className="contents-container">
            <p>求人掲載企業<br className="sp_only"/>どんどん増えてます！</p>
            <picture>
                <source media="(max-width: 950px)" srcSet="https://job.parachannel.jp/assets/img/enterprise_logo_sp.png"/>
                <source media="(max-width: 1140px)" srcSet="https://job.parachannel.jp/assets/img/enterprise_logo.png"/>
                <img src="https://job.parachannel.jp/assets/img/enterprise_logo.png" alt=""/>
            </picture>
            </div>
        </section>
    
        <section className="section_voice bg_beige">
            <div className="contents-container" id="voice">
            <h2>採用担当者の声</h2>
            <ul className="voice_list">
                <li className="voice_item">
                    {/* <!-- <img src="/assets/img/voice_photo00.jpg" alt=""/> --> */}
                    <ul className="voice_tag">
                    <li>ライター</li>
                    <li>在宅勤務</li>
                    <li>契約社員</li>
                    </ul>
                    <h3>ハローワークと併用して利用を開始しました。担当者が少数で忙しい中、求人作成から応募管理までお任せできるこのサービスに、今後が楽しみです。</h3>
                    {/* <!-- <p>株式会社キャリアート様</p> --> */}
                </li>
                <li className="voice_item">
                {/* <!-- <img src="/assets/img/voice_photo-d.jpg" alt=""> --> */}
                <ul className="voice_tag">
                    <li>事務</li>
                    <li>東京</li>
                    <li>正社員</li>
                </ul>
                <h3>サービス内でのSNS拡散が効果的で、多くの人に求人情報が届いているようです。スカウト機能で効率的に採用活動を進められるようになりました。</h3>
                </li>
                <li className="voice_item">
                {/* <!-- <img src="/assets/img/voice_photo-d.jpg" alt=""> --> */}
                <ul className="voice_tag">
                    <li>販売</li>
                    <li>神奈川</li>
                    <li>契約社員</li>
                </ul>
                <h3>面接後の不合格通知の対応が億劫だったのですが、パラちゃんねるでは自動化してくれているので手間が減って助かっています。</h3>
                </li>
                <li className="voice_item">
                {/* <!-- <img src="/assets/img/voice_photo-d.jpg" alt=""> --> */}
                <ul className="voice_tag">
                    <li>製造</li>
                    <li>愛知</li>
                    <li>正社員</li>
                </ul>
                <h3>障害者雇用に特化した求人を出せる場所が少なかったので、このサービスに出会えて希望が湧いています。</h3>
                </li>
                <li className="voice_item">
                {/* <!-- <img src="/assets/img/voice_photo-d.jpg" alt=""> --> */}
                <ul className="voice_tag">
                    <li>小売</li>
                    <li>大阪</li>
                    <li>パート・アルバイト</li>
                </ul>
                <h3>面接の不安点も気軽に質問できて、一緒に採用活動してくれる感覚があります。</h3>
                </li>
                <li className="voice_item">
                {/* <!-- <img src="/assets/img/voice_photo-d.jpg" alt=""> --> */}
                <ul className="voice_tag">
                    <li>清掃</li>
                    <li>福岡</li>
                    <li>パート・アルバイト</li>
                </ul>
                <h3>ハローワークでも常に募集苦戦。だけど時間や手間は掛けられない。パラちゃんねるの原稿作成サポートを活用して、手軽に掲載スタート。写真やコラム記事は現場スタッフに協力してもらい、職場の雰囲気が伝わるようにしたところ、応募が複数発生！</h3>
                </li>
            </ul>
            </div>
        </section>
    
        <section className="section_flow bg_stripe_lite_blue">
            <div className="contents-container" id="flow">
            <p className="lead_text"><span>専属チームが作成から<br className="sp_only"/>採用までトータルサポートする</span></p>
            <h2>ご利用の流れ</h2>
            </div>
            <picture>
            <source media="(max-width: 950px)" srcSet="/assets/img/flow_img_sp.png"/>
            <source media="(max-width: 1140px)" srcSet="/assets/img/flow_img.png"/>
            <img src="/assets/img/flow_img.png" alt=""/>
            </picture>
        </section>
    
        <section className="section_thought bg_yellow">
            <div className="contents-container">
            <h2>サービスを立ち上げた想い</h2>
    
            <div className="thought_movie">
                <iframe className="" width="850" height="450" src="https://www.youtube.com/embed/dPbFjhcKgo4" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" ></iframe>
            </div>
    
            <div className="flex">
                <div className="img_box_thought">
                <img src="/assets/img/thought_photo.jpg" alt=""/>
                <div className="thought_name">
                    <p>パラちゃんねる<br/><span>代表取締役 中塚翔大</span></p>
                </div>
                </div>
                <div className="text_box">
                <p>大学卒業後に働いた人材会社でリーマンショックを経験し、世の中には努力ではどうにもならないことがある、と実感しました。それと同時に「個人の力ではどうにもならない社会課題を解決しなくては」と決意を固め起業するに至ります。<br/>
                    とくに人材業界のマッチングはスキルや経験などを重視する傾向があります。どうしても障がい者や障がいなどにより生きづらさを抱える人がこぼれ落ちてしまう。そこで、誰もが自由に出会えるプラットフォームを作ろうと考え「パラちゃんねる」を立ち上げました。<br/>
                    大切にしたのは、求職者も企業も使いやすいということ。たとえば、求職者の最初の壁となる「志望動機」はエントリー時点では不要、企業は最初の2年間は掲載無料など、使いやすさにこだわることで、今まで出会えてなかった求職者と企業がそれぞれの意志で出会える仕組みを整えています。<br/>
                    いろいろな特性を持った方々が働きやすい職場になれば、結果、その企業の成長が持続的に可能になる、と考えています。<br/>
                    今後もサービスの改善に努め、「誰も取り残されない社会をつくる」というビジョンを実現して参ります。</p>
                </div>
            </div>
    
            <div className="flat_box">
                <div className="flat_box_inner">
                <div className="img_box_flat">
                    <img src="/assets/img/thought_img.png" alt="障がい者雇用担当者交流会「flat」"/>
                </div>
                <div className="text_box">
                    <p>「flat」は、障がい者雇用担当者のためのコミュニティです。私たちは、2022年に全国3000名以上の障がい者雇用担当者と対話し、彼らが直面する課題を理解してきました。障がい者雇用のはじめ方がわからない方や、業務の切り出しや受け入れ部署の開拓に苦労している方、相談する場所がない方、新卒採用や兼業の課題を抱える方、トップの理解が足りない方など、さまざまな悩みがあります。「flat」は、障がい者雇用担当者を支援し、職場での雇用促進に全面的なサポートを提供するチームとしてコミュニティを形成しています。</p>
                    <p className="link"><a href="https://www.canva.com/design/DAFYfR70Vb8/HczpNCcQXEBwRHro-pvhfA/view" target="_blank">詳しくはこちら</a></p>
                </div>
                </div>
            </div>
    
            </div>
        </section>
    
        <section className="section_faq bg_lattice">
            <div className="contents-container" id="faq">
            <h2>よくある質問</h2>
    
            <div className="faq_box ">
                <h3>掲載について</h3>
    
                <dl className="faq_item">
                <dt className="question"><span>Q</span>どの地域でも掲載できるの？</dt>
                <dd className="answer" style={{display:"none"}}><p>日本全国で掲載可能です。また、在宅・リモート案件も掲載可能となります。</p></dd>
                </dl>
                <dl className="faq_item">
                <dt className="question"><span>Q</span>掲載できる雇用形態は？</dt>
                <dd className="answer" style={{display:"none"}}><p>直接雇用が対象となります。<br/>
                    （正社員、契約社員、パート・アルバイト、嘱託社員、請負社員、アスリート雇用等）
                    </p></dd>
                </dl>
            </div>
    
            <div className="faq_box ">
                <h3>料金について</h3>
                
                <dl className="faq_item">
                <dt className="question"><span>Q</span>どうして無料掲載なの？</dt>
                <dd className="answer" style={{display: "none"}}><p>従来の求人サイトの高すぎる掲載料・手数料が生みだすスキル重視のマッチング市場は、特性や配慮などの相互理解を軸とした障がい者雇用には適しておらず、より気軽な対話の機会を増やすために無料掲載としております。</p></dd>
                </dl>
                <dl className="faq_item">
                <dt className="question"><span>Q</span>いつまで無料で使えるの？</dt>
                <dd className="answer" style={{display: "none"}}><p>基本機能は無料でご利用いただけます。<br/>
                    2024年4月よりオプション課金制を導入予定です。<br/>
                    ※自動の課金など一方的なご請求はありませんのでご安心ください。
                    </p></dd>
                </dl>
                <dl className="faq_item">
                <dt className="question"><span>Q</span>助成金の対象になる？</dt>
                <dd className="answer" style={{display: "none"}}><p>
                    株式会社キャリアートは、「雇用関係助成金」を取り扱う職業紹介事業者として認定を受けています。職業紹介事業者等が取り扱っている助成金は「雇用給付金」です。なお、それぞれの助成金には一定の支給要件がありますのでご確認ください。
                    </p>
                    <ul className='ul_lp'>
                    <li><a href="https://www.mhlw.go.jp/stf/seisakunitsuite/bunya/koyou_roudou/koyou/kyufukin/tokutei_konnan.html" target="_blank">特定求職者雇用開発助成金（特定就職困難者コース）</a></li>
                    <li><a href="https://www.mhlw.go.jp/stf/seisakunitsuite/bunya/koyou_roudou/koyou/kyufukin/hattatsu_nanchi.html" target="_blank">特定求職者雇用開発助成金（発達障害者・難治性疾患患者雇用開発コース</a></li>
                    <li><a href="https://www.mhlw.go.jp/stf/seisakunitsuite/bunya/0000158169_00001.html" target="_blank">特定求職者雇用開発助成金（就職氷河期世代安定雇用実現コース）</a></li>
                    <li><a href="https://www.mhlw.go.jp/stf/seisakunitsuite/bunya/koyou_roudou/koyou/kyufukin/tokutei_seikatsu.html" target="_blank">特定求職者雇用開発助成金（生活保護受給者等雇用開発コース）</a></li>
                    <li><a href="https://www.mhlw.go.jp/seisakunitsuite/bunya/koyou_roudou/koyou/kyufukin/chiiki_koyou.html" target="_blank">地域雇用開発助成金（地域雇用開発コース）</a></li>
                    <li><a href="https://www.mhlw.go.jp/stf/seisakunitsuite/bunya/koyou_roudou/koyou/newpage_16286.html" target="_blank">トライアル雇用助成金（一般トライアルコース）</a></li>
                    <li><a href="https://www.mhlw.go.jp/stf/seisakunitsuite/bunya/koyou_roudou/koyou/kyufukin/shougai_trial.html" target="_blank">トライアル雇用助成金（障害者（短時間）トライアルコース）</a></li>
                    <li><a href="https://www.mhlw.go.jp/stf/seisakunitsuite/bunya/koyou_roudou/koyou/kyufukin/tokutei_seichou_00008.html" target="_blank">特定求職者雇用開発助成金（成長分野等人材確保・育成コース）</a></li>
                    </ul>
                    <p>
                    ハローワーク求人・求職者提供サービス<br/>
                    利用番号:PB0102983
                </p></dd>
                </dl>
            </div>
    
            <div className="faq_box ">
                <h3>ご利用いただくにあたって</h3>
                
                <dl className="faq_item">
                <dt className="question"><span>Q</span>どんな機能がある？</dt>
                <dd className="answer" style={{display:"none"}}><p>主なサービスとしては求人掲載、スカウト機能、記事コラム作成機能、合否連絡の自動化、カンタン面接設定があります。</p></dd>
                </dl>
                <dl className="faq_item">
                <dt className="question"><span>Q</span>運営している会社は？</dt>
                <dd className="answer" style={{display:"none"}}><p>株式会社キャリアートは、障がい者専門の就職支援を行う会社となります。多様性を推進するプロジェクト「パラちゃんねる」としてラジオ、コラムサイト、本求人サイトの運営を行っています。株式会社キャリアートのWEBサイトは<a href="https://www.careerart.net/">こちら</a></p></dd>
                </dl>
            </div>
    
            <div className="faq_box ">
                <h3>使い方・サポートについて</h3>
                
                <dl className="faq_item">
                <dt className="question"><span>Q</span>どこかにマニュアルはありますか？</dt>
                <dd className="answer" style={{display:"none"}}><p>ご利用者ガイド？（<a href="/guide/">使い方ガイド</a>）をご活用ください。</p></dd>
                </dl>
            </div>
            </div>
        </section>
    
        <div className="cta_box bg_blue">
            <div className="contents-container">
            <p className="h_text">毎月300人以上の新規求職者が登録中！</p>
            <div className="flex">
                <div className="button-container">
                <p className="sup_text">簡単3分</p>
                    <a className="button yellow" href="/recruiter/signup/">無料で掲載をはじめる</a>
                </div>
                <div className="button-container">
                <p className="sup_text">5分でパラちゃんねるがわかる</p>
                    <a className="button white_yellow" href="https://form.k3r.jp/parachannel/parachannel4corporate?k3ad=recruit_lp" target="_blank">資料ダウンロード</a>
                </div>
            </div>
            </div>
        </div>
    
    
        <section className="section_inqu bg_stripe_blue">
            <div className="contents-container">
            <h3>メールでのお問い合わせはこちら</h3>
            <p>1営業日以内に折り返し<br className="sp_only"/>ご連絡させていただきます</p>
            <div className="button-container">
                <a className="button white_blue" href="mailto:recruit@parachannel.jp"><span>メールはこちらから</span></a>
            </div>
            </div>
        </section>
    
        </main>
    
        <footer className="">
        © 2009 - 2030 parachannnel
        </footer>
        {/* <chat>
            <div id="chatplusview" role="application" aria-label="ChatPlus" className=" chatplusview-basic front     closed        " aria-expanded="false"> 
            <div id="outline"> <div id="chatpluscontent">  <div id="eye_catcher" className="eyecatcher-no_chat" aria-controls="chatplusview"> 
            <img src="https://appimg.chatplus.jp/app/20461/eyecatcher/eyecatcher.1697200154.png" alt="ご相談ください" width="309" height="94"/>   </div>  
            <div id="chatplusheader" aria-controls="chatplusview"> <div id="profile" className="profile" role="heading"> 
            <span className="name">ご訪問ありがとうございます。</span> </div> <div className="operate">     </div> </div> <div id="body" aria-hidden="true"> <h2> 
                <div className="icon"><i role="presentation" aria-hidden="true" class="cpfas fa-comments fa-3x"></i></div> 
                <div className="text"><abr cptag="1" content="ご不明な点がありましたら、チャットでお答えします。">ご不明な点がありましたら、チャットでお答えします。</abr></div> </h2> <form id="form-start" className="form-horizontal" onsubmit="return false;">         
                <div className="error-message"></div> <div className="form-group btn-container"> <button id="start_btn" type="button" className="btn btn-block"> <span>チャットを開始する</span> 
                </button> </div>   </form> <div id="option_form" hidden="" style="display: none;"> 
                <div className="operate"> <div className="input-file">オプション</div> <div className="options"> <div><label><input type="checkbox" name="mute"/>&nbsp;通知音を出さない</label></div> 
                </div> <div className="button-container"> <button className="btn btn-sm" type="button"><span>適用</span></button> 
                <button className="btn btn-sm" type="button"><span>キャンセル</span></button> </div> </div> </div> </div> <div id="chatplusfooter"> <span className="footer option"></span> <span className="deprecated-secondary-font style-background-color footer powered"><a role="button">Powered by Chat Plus</a></span> </div> </div> </div>    
                <div className="buttons"> <button id="openChat"></button> <button id="closeChat"></button> <button id="showChat"></button> <button id="hideChat"></button> 
                <button id="quitChat"></button> </div> </div></chat>     */}
            {/* <chat><div id="chatplusview" role="application" aria-label="ChatPlus" class=" chatplusview-basic front     closed        " aria-expanded="false"> <div id="outline"> <div id="chatpluscontent">  <div id="eye_catcher" class="eyecatcher-no_chat" aria-controls="chatplusview" tabindex="0"> <img src="https://appimg.chatplus.jp/app/20461/eyecatcher/eyecatcher.1697200154.png" alt="ご相談ください" width="309" height="94">   </div>  <div id="chatplusheader" aria-controls="chatplusview" tabindex="0"> <div id="profile" class="profile" role="heading"> <span class="name">ご訪問ありがとうございます。</span> </div> <div class="operate">     </div> </div> <div id="body" aria-hidden="true"> <h2> <div class="icon"><i role="presentation" aria-hidden="true" class="cpfas fa-comments fa-3x"></i></div> <div class="text"><abr cptag="1" content="ご不明な点がありましたら、チャットでお答えします。">ご不明な点がありましたら、チャットでお答えします。</abr></div> </h2> <form id="form-start" class="form-horizontal" onsubmit="return false;">         <div class="error-message"></div> <div class="form-group btn-container"> <button id="start_btn" type="button" class="btn btn-block"> <span>チャットを開始する</span> </button> </div>   </form> <div id="option_form" hidden="" style="display: none;"> <div class="operate"> <div class="input-file">オプション</div> <div class="options"> <div><label><input type="checkbox" name="mute">&nbsp;通知音を出さない</label></div> </div> <div class="button-container"> <button class="btn btn-sm" type="button"><span>適用</span></button> <button class="btn btn-sm" type="button"><span>キャンセル</span></button> </div> </div> </div> </div> <div id="chatplusfooter"> <span class="footer option"></span> <span class="deprecated-secondary-font style-background-color footer powered"><a role="button" tabindex="0">Powered by Chat Plus</a></span> </div> </div> </div>    <div class="buttons"> <button id="openChat"></button> <button id="closeChat"></button> <button id="showChat"></button> <button id="hideChat"></button> <button id="quitChat"></button> </div> </div></chat> */}
        </div>
        <img src="https://t.co/1/i/adsct?bci=4&amp;eci=3&amp;event=%7B%7D&amp;event_id=321d9afe-f525-4501-a045-d5a502c5154d&amp;integration=gtm&amp;p_id=Twitter&amp;p_user_id=0&amp;pl_id=2af9baf0-95fc-4661-a620-5d63a272a43f&amp;tw_document_href=https%3A%2F%2Fjob.parachannel.jp%2Frecruiter_lp%2F&amp;tw_iframe_status=0&amp;txn_id=od3wn&amp;type=javascript&amp;version=2.3.29" height="1" width="1" style={{display : "none"}}/>
        <img src="https://analytics.twitter.com/1/i/adsct?bci=4&amp;eci=3&amp;event=%7B%7D&amp;event_id=321d9afe-f525-4501-a045-d5a502c5154d&amp;integration=gtm&amp;p_id=Twitter&amp;p_user_id=0&amp;pl_id=2af9baf0-95fc-4661-a620-5d63a272a43f&amp;tw_document_href=https%3A%2F%2Fjob.parachannel.jp%2Frecruiter_lp%2F&amp;tw_iframe_status=0&amp;txn_id=od3wn&amp;type=javascript&amp;version=2.3.29" height="1" width="1" style={{display : "none"}}></img>
        </>
    );
  }
  
  export default Recruiter;